import type { Address } from '../../types/commons';
import { validateZipCode } from './zip-code';

// This validation does not take into account the country code
// use on the pro side
// @deprecated
export const validateAddressLegacy = (value?: Partial<Address>): value is Address =>
  !!(
    value?.zip_code &&
    validateZipCode(value.zip_code) &&
    value.address &&
    value.city &&
    value.street_name &&
    (value.lat || value.lat === 0) &&
    (value.lng || value.lng === 0)
  );

export const validateAddress = (value?: Partial<Address>): value is Address =>
  !!(
    value &&
    validateZipCode(value.zip_code) &&
    value.address &&
    value.city &&
    value.country_code &&
    (value.lat || value.lat === 0) &&
    (value.lng || value.lng === 0) &&
    value.street_name &&
    value.zip_code
  );
